import { toLower } from 'lodash';
import envConfig from '../../static/config';
import { dybToB } from '../utils/ResourceLoaderUtils';

const getPageUrl = (segment) => {
  return `/${toLower(dybToB(envConfig.brandId))}/${segment}`;
};

const taskUrls = () => {
  return {
    capture: getPageUrl(''),
    idcheckfail: getPageUrl('sorry'),
    idcheckcannotbedone: getPageUrl('id-deferred'),
    challenge: getPageUrl('security'),
    creditcheckdeclined: getPageUrl('sorry'),
    creditcheckreferred: getPageUrl('deferred'),
    offer: getPageUrl('offer'),
    fulfillmentinprogress: getPageUrl('registration'),
    productsetupinprogress: getPageUrl('setup-in-progress'),
    applicationexpired: getPageUrl('deferred'),
    cancelled: getPageUrl('sorry'),
    applicationrejected: getPageUrl('decline'),

    'WEB-AUTHENTICATION': getPageUrl('authentication'),
    'WEB-SUBMIT-FORM': getPageUrl('submission'),
    'WEB-SUBMIT-CALL3D': getPageUrl('submission'),
    'WEB-ACCOUNT-OPENED': getPageUrl('account-opened'),
    'WEB-ELIGIBILITY-PAGE': getPageUrl(''),
    'WEB-PERSONAL-DETAILS': getPageUrl('step-1'),
    'WEB-PERSONAL-DETAILS-PERSONAL': getPageUrl('step-1#personal-details'),
    'WEB-PERSONAL-DETAILS-CONTACT': getPageUrl('step-1#contact-details'),
    'WEB-EMPLOYMENT-DETAILS': getPageUrl('step-2'),
    'WEB-EMPLOYMENT-DETAILS-NATIONALITY': getPageUrl(
      'step-2#nationality-details'
    ),
    'WEB-EMPLOYMENT-DETAILS-EMPLOYMENT': getPageUrl(
      'step-2#employment-details'
    ),
    'WEB-EMPLOYMENT-DETAILS-INCOME': getPageUrl('step-2#income-details'),
    'WEB-EMPLOYMENT-DETAILS-OUTGOINGS': getPageUrl('step-2#outgoings-details'),
    'WEB-EMPLOYMENT-DETAILS-SAVINGS': getPageUrl(
      'step-2#savings-account-details'
    ),
    'WEB-MANAGE-PERSONAL-DETAILS': getPageUrl('manage-details'),
    'WEB-CONTACT-PREFERENCES': getPageUrl('contact-preferences'),
    'WEB-REVIEW-DETAILS': getPageUrl('review'),
    'WEB-REGISTRATION': getPageUrl('registration'),
    'WEB-SWITCH': getPageUrl('switch'),
    'WEB-ERROR': getPageUrl('error'),
    'WEB-NONBCUSTOMERERROR': getPageUrl('nonberror'),
    'WEB-INVALIDTOKENSESSIONTIMEOUT': getPageUrl('session-expired'),
    'WEB-ERROR-PAGE': getPageUrl('error-page'),
    'WEB-PORTAL': getPageUrl('portal'),
    'WEB-LOGIN': getPageUrl('login'),
    'WEB-DECLINE-ID': getPageUrl('sorry'),
    'WEB-CONTACT-BANK': getPageUrl('contact-bank'),
    'WEB-TIMELINE': getPageUrl('timeline'),
    'WEB-OPEN-PAYMENTS': getPageUrl('payments'),
    'WEB-OPEN-MOVEMONEY': getPageUrl('movemoney'),
    'WEB-OPEN-MOVEMONEY-PAYMENTS': getPageUrl('movemoney/batchpayments'),
    'WEB-OPEN-MOVEMONEY-REPEAT-PAYMENTS': getPageUrl(
      'movemoney/repeat-payment'
    ),
    'WEB-OPEN-MOVEMONEY-REVIEW': getPageUrl('movemoney/review'),
    'WEB-OPEN-MOVEMONEY-SUBMITTED': getPageUrl('movemoney/submitted'),
    'WEB-OPEN-SPENDINGS': getPageUrl('spendings'),
    'WEB-OPEN-FINANCIAL_STORIES': getPageUrl('financialstories'),
    'WEB-OPEN-SAVING-POTS': getPageUrl('savingpots'),
    'WEB-OPEN-HELP': getPageUrl('help'),
    'WEB-OPEN-FAQ': getPageUrl('faq'),
    'WEB-OPEN-LOGOUT': getPageUrl('logout'),
    'WEB-HOLDING-PAGE': getPageUrl('handle-logout'),
    'WEB-PAYMENT-CONFIRM': getPageUrl('confirmpayment'),
    'WEB-PAYMENT-THANKYOU': getPageUrl('finalpayment'),
    'WEB-PAYMENT-BACK': getPageUrl('payments'),
    'WEB-MANAGE-PAYMENT': getPageUrl('managepayment'),
    'WEB-EDIT-PAYMENT': getPageUrl('editpayment'),
    'WEB-EDIT-PAYMENT-SUCCES': getPageUrl('successEdit'),
    'WEB-VIEW-PAYMENT': getPageUrl('viewpayment'),
    'WEB-MANAGE-PAYEE': getPageUrl('managepayee'),
    'WEB-ARCHIEVED-PAYMENT': getPageUrl('archivedpayment'),
    'WEB-ADD-PAYEE': getPageUrl('addPayee'),
    'WEB-VIEW-PAYEE': getPageUrl('viewPayee'),
    'WEB-ACCOUNT-LOCKED': getPageUrl('account-locked'),
    'WEB-PAYMENT-THANKYOU-MOVEMONEY': getPageUrl('thankyou'),
    'WEB-ACCOUNT-DETAILS': getPageUrl('account-view'),
    'WEB-PRODUCT-INFO': getPageUrl('product'),
    'WEB-PROJECTIONS': getPageUrl('projections'),
    'WEB-HOMEPAGE': getPageUrl('homepage'),
    'WEB-DIGITAL-STATEMENTS': getPageUrl('statements'),
    'WEB-STATEMENTS-PREFERENCES': getPageUrl('statementspreferences'),
    'WEB-INTERMEDIATE': getPageUrl('inner'),
    'WEB-ACCOUNT-PREFERENCES': getPageUrl('accountpreference'),
    'WEB-ORDER-STATEMENT': getPageUrl('orderstatement'),
    'WEB-ORDER-PAY-IN': getPageUrl('orderpayin'),
    'WEB-ORDER-CHEQUE': getPageUrl('ordercheque'),
    'WEB-MANAGE-CREDENTIALS': getPageUrl('managecredentials'),
    'WEB-SECURE-MESSAGE': getPageUrl('securemessage'),
    'WEB-DOCUMENT-LIBRARY': getPageUrl('my-documents'),
    'WEB-EXPORT-TRANSACTION': getPageUrl('exporttransaction'),
    'WEB-RENAME-ACCOUNT': getPageUrl('renameaccount'),
    'WEB-MANAGE-PAYMENT-STATUS': getPageUrl('paymentStatus'),
    'WEB-ACTIVATE-YOUR-SECURITY-TOKEN': getPageUrl('activateYourSecurityToken'),
    'WEB-BENEFICIARY-SYNC': getPageUrl('beneficiarysync'),
    'WEB-OPEN-ALERTS': getPageUrl('alertsnsweeps'),
    'WEB-ACCOUNT-PICKER': getPageUrl('accountpicker'),
    'WEB-MANAGE-CARD': getPageUrl('manage-cards'),
    'WEB-ACCOUNT-POOLS': getPageUrl('account-pool'),
    'WEB-CREATE-POOL': getPageUrl('account-pool/create'),
    'WEB-ACCOUNT-POOL-DETAILS': getPageUrl('account-pool/get'),
    'WEB-M-TRACK': getPageUrl('m-track'),
    'WEB-MANAGE-INSURANCE': getPageUrl('manage-insurance'),
    'WEB-PRIVATE-ACOOUNT-BENEFITS': getPageUrl('private-banking-benefits'),
    'WEB-CURRENT-TRACKER-BENEFITS': getPageUrl('current-tracker-benefits'),
    'WEB-LAST-LOGIN': getPageUrl('last-login'),
    'WEB-GIVING_NOTICE': getPageUrl('giving-notice'),
  };
};

export default taskUrls;
